module.exports = __webpack_public_path__ + "static/media/whichThinnerChoice.50aaad38.mp3";